import { ApiService } from "../../../server/api/client";

import type { ApiResponse } from "../../../server/api/client";
import type { UUID } from "../../../utils/uuid";

export class VideoUidService extends ApiService {
  module = "video";

  async upsert(uid: string, id?: UUID): Promise<ApiResponse<{ id: UUID }>> {
    return await this.post("assetUid", { uid, id });
  }
}
